import { Dropdown } from "semantic-ui-react";
import Logo from "../images/twicelogo.jpg";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <div className="navbar">
      <ul>
        <Link to="/">
          <li className="logo">
            <img src={Logo} alt="" />
          </li>
        </Link>
        <Link to="/" style={{ textDecoration: "none", color: "black" }}>
          <li path="photos">Home</li>
        </Link>

        <li>
          <Dropdown text="Teaser">
            <Dropdown.Menu>
              <Link
                to="/photos"
                style={{ textDecoration: "none", color: "black" }}
              >
                <Dropdown.Item>Teaser Photos</Dropdown.Item>
              </Link>
              <Link
                to="/videos"
                style={{ textDecoration: "none", color: "black" }}
              >
                <Dropdown.Item text="Teaser Videos"></Dropdown.Item>
              </Link>
            </Dropdown.Menu>
          </Dropdown>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
